import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loader, Notes, SimpleTabs } from 'components';
import { FindLoad, Images, noteModels, PermissionList, useModal } from 'utils';
import { formModelEnums } from 'pages';
// import { Graph } from './graph';
import { Score } from './score';
import { assessmentActions } from 'store';
import moment from 'moment/moment';
import { renderAssessmentName } from './constants';
import { AddAssessment } from './addAssessment';
import { GoAssessment } from './goAssessment';

const tabDetailsLabels = [
    { label: 'Scores' },
    // { label: 'Graph' },
    { label: 'Note' },
];

const ACTION_TYPE = 'GET_ASSESSMENT_BY_ID';
export const AssessmentDetails = ({ assessmentId, renderParams }) => {
    const assessmentDetails = useSelector((state) => state.assessment.assessmentById);
    const [tab, setTab] = useState('Scores');
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const { open } = useModal();

    const tabsContent = [
        {
            tabComponent: <Score />,
            tab: 'Scores',
        },
        // {
        //     tabComponent: <Graph />,
        //     tab: 'Graph',
        // },
        {
            tabComponent: (
                <Notes
                    id={assessmentId}
                    onModel={noteModels.Assessment}
                    formModel={formModelEnums.PAYERNOTES}
                    permissions={[PermissionList.FS_NOTE_MANAGE?.code]}
                />
            ),
            tab: 'Note',
        },
    ];

    useEffect(() => {
        if (assessmentId) {
            dispatch(assessmentActions.getAssessmentBiId(assessmentId));
        }
    }, [dispatch]);

    if (loader?.length) {
        return (
            <div style={{ width: 1200, maxWidth: '100%', height: '75vh' }}>
                <Loader />
            </div>
        );
    }

    return (
        <div style={{ width: 1200, maxWidth: '100%', height: '75vh' }}>
            <div className="space-between" style={{ marginBottom: 20 }}>
                <h1 className="assessment-detail-title">Assessment Details</h1>
                <div className="flex-align-center" style={{ gap: 8 }}>
                    <div className="assessment-detail-info-box">
                        <p className="assessment-detail-info-title">Tool:</p>
                        <div className="space-between">
                            <h5 className="assessment-detail-info-value">{renderAssessmentName(assessmentDetails?.type)}</h5>
                            {assessmentDetails?.type === 'VB_MAPP' && (
                                <button
                                    onClick={() => open(<GoAssessment requestParams={renderParams} />)}
                                    className="assessment-detail-go-btn"
                                >
                                    <p>Go</p>
                                    <img
                                        style={{
                                            filter: 'brightness(0) saturate(100%) invert(22%) sepia(92%) saturate(3071%) hue-rotate(209deg) brightness(97%) contrast(91%);',
                                        }}
                                        src={Images.arrowRight}
                                        alt="arrowRight"
                                    />
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="assessment-detail-info-box">
                        <p className="assessment-detail-info-title">Tool:</p>
                        <h5 className="assessment-detail-info-value">
                            {assessmentDetails?.startDate ? moment.utc(assessmentDetails?.startDate).format('MM/DD/YYYY') : '--'}
                        </h5>
                    </div>
                    <div className="assessment-detail-info-box">
                        <p className="assessment-detail-info-title">Color:</p>
                        <div
                            // style={{ background: '#FEF3F2' }}
                            className="assessment-detail-color-row"
                        >
                            <div style={{ background: assessmentDetails?.color }} />
                            {/*<p style={{ color: '#B42318' }}>Red</p>*/}
                        </div>
                    </div>
                </div>
            </div>

            <SimpleTabs tab={tab} getTab={setTab} defaultTab={'Scores'} tabsLabels={tabDetailsLabels} tabsContent={tabsContent} />
        </div>
    );
};
